<ngx-loading
  [show]="loader"
  [config]="{ backdropBorderRadius: '0px' }"
></ngx-loading>
<div class="page">
  <!-- <app-header></app-header> -->
  <p class="pageTitle">Contact Sales</p>
  <p class="subtitle">
    Tell us more about your business and our team will get in touch with you!
  </p>
  <div [ngClass]="success ? 'ffcomp3' : ''" class="comp ffcomp container">
    <div [ngClass]="success ? '' : 'flipped'" class="feelFree">
      <form [formGroup]="myform" (ngSubmit)="onSubmit()" class="feelFreeBack">
        <div class="row">
          <mat-form-field
            [hideRequiredMarker]="true"
            class="txtInput usernameInput col-12 col-md-6"
          >
            <mat-label>First Name </mat-label>
            <input formControlName="firstName" required matInput />
          </mat-form-field>

          <mat-form-field
            [hideRequiredMarker]="true"
            class="txtInput usernameInput col-12 col-md-6"
          >
            <mat-label>Last Name </mat-label>
            <input formControlName="lastName" required matInput />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field
            [hideRequiredMarker]="true"
            class="txtInput usernameInput col-12 col-md-6"
          >
            <mat-label>Email </mat-label>
            <input formControlName="email" required matInput />
          </mat-form-field>

          <mat-form-field
            [hideRequiredMarker]="true"
            class="txtInput usernameInput col-12 col-md-6"
          >
            <mat-label>Mobile Number </mat-label>
            <input formControlName="phone" required matInput />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field
            [hideRequiredMarker]="true"
            class="txtInput col-12 col-md-6"
          >
            <mat-label>Business Name </mat-label>
            <input formControlName="businessName" required matInput />
          </mat-form-field>

          <mat-form-field [hideRequiredMarker]="true" class="col-12 col-md-6">
            <mat-label>Category</mat-label>
            <mat-select
              (selectionChange)="onSelectCatagory($event)"
              formControlName="category"
              required
            >
              <mat-option
                style="
                  color: #4d4d4d;
                  font-weight: 500;
                  font-family: Gill Sans, Gill Sans MT, Calibri, Trebuchet MS,
                    sans-serif;
                "
                *ngFor="let item of catagory"
                [value]="item"
              >
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field class="txtInput usernameInput col-12 col-md-6">
            <mat-label>Website (optional) </mat-label>
            <input formControlName="message" matInput />
            <!-- <textarea formControlName="message" matInput></textarea> -->
          </mat-form-field>
        </div>

        <div class="bottomForm">
          <button type="submit" class="formCta">Send Message</button>
        </div>
      </form>

      <div class="feelFreeFront">
        <form class="success">
          <img src="../../../assets/images/success.gif" />
          <p class="successT1">Thank you!</p>
          <p class="successT2">
            Your message has been submitted successfully, we’ll get in
            touch with you soon.
          </p>
        </form>
      </div>
    </div>
  </div>

  <p class="pageTitle">Email us</p>
  <div class="emails container">
    <div class="emailCard">
      <p class="emailCardTitle1">Sales Inquiries</p>
      <a href="mailto: sales@klickit.co" class="emailCardTitle2">
        sales@klickit.co
      </a>
    </div>

    <div class="emailCard">
      <p class="emailCardTitle1">Technical Support Inquiries</p>
      <a href="mailto: support@klickit.co" class="emailCardTitle2"
        >support@klickit.co</a
      >
    </div>

    <div class="emailCard">
      <p class="emailCardTitle1">General Inquiries</p>
      <a href="mailto: info@klickit.co" class="emailCardTitle2"
        >info@klickit.co</a
      >
    </div>
  </div>
</div>
